<template>
  <div v-if="video && course">
    <!-- video selectionnée -->
    <div class="d-flex flex-row flex-wrap mx-2">
      <div class="p-2 col-xl-8 col-lg-8 col-md-12 col-sm-12">
        <video-item
          :video="video"
          :nextVideo="nextVideo"
        ></video-item>

        <!-- previous && next video courses -->
        <div class="d-flex flex-row justify-content-between">
          <div v-if="previousVideo && course">
            <router-link
              :to="{
                name: 'videoFromCourse',
                params: {
                  id: previousVideo.id,
                  video: previousVideo,
                  idParcours: course.id,
                },
              }"
            >
              <a class="btn btn-primary">{{ $t("course.videoPrecedente") }}</a>
            </router-link>
          </div>
          <div v-else></div>
          <div v-if="nextVideo && course">
            <router-link
              :to="{
                name: 'videoFromCourse',
                params: {
                  id: nextVideo.id,
                  video: nextVideo,
                  idParcours: course.id,
                },
              }"
            >
              <a class="btn btn-primary">{{ $t("course.videoSuivante") }}</a>
            </router-link>
          </div>
          <div v-else></div>
        </div>
      </div>

      <div class="p-2 col-xl-4 col-lg-4 col-md-12 col-sm-12">
        <!-- autres videos du theme selectionné -->
        <h6>
          <!-- {{ course.videos.length }} vidéo<span v-if="course.videos.length > 1"
            >s</span
          >
          contenue<span v-if="course.videos.length > 1">s</span> dans le
          parcours
          {{ course.title }} -->

          {{
            $tc("course.title", course.videos.length, { param: course.title })
          }}
        </h6>
        <CourseItemVertical
          :course="course"
          :video="video"
        ></CourseItemVertical>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import VideoItem from "@/components/video/videoItem";
import CourseItemVertical from "@/components/course/courseItemVertical";

export default {
  name: "videoFromCourse",
  components: {
    VideoItem,
    CourseItemVertical,
  },
  data: () => ({
    dataLoaded:false,
    videoId: null,
    video: null,
    course: null,
    nextVideo: null,
    previousVideo: null,
  }),
  mounted() {
    this.refreshVideoDetail();
  },
  methods: {
    refreshVideoDetail() {
      const videoId = this.$route.params.id;
      const courseId = this.$route.params.idParcours;

      Api.get(`/videos/${videoId}`)
        .then((video) => {
          this.video = video.data;
          Api.get(`/courses/${courseId}`).then((course) => {
            this.course = course.data;

            this.$store.dispatch(SET_BREADCRUMB, [
              { title: "Parcours", route: "bibliothequeParcours" },
              { title: this.course.title },
              { title: this.video.title },
            ]);
            this.getNextCourseVideo();
            this.getPreviousCourseVideo();
          });
        })
        .catch((error) => {
          //console.log(error);
          return error;
        });
    },
    setCourseVideoRoute(video){
      if(video){
        video.route = {
            name: 'videoFromCourse',
            params: {
              id: video.id,
              video: this.video,
              idParcours: this.course.id,
            }
        }
      }
    },
    getNextCourseVideo() {
      var currentVideoIndex = this.course.videos.findIndex(
        (courseVideo) => courseVideo["@id"] == this.video["@id"]
      );
      if ((currentVideoIndex + 1) > 0 && this.course.videos.length >= (currentVideoIndex + 1)) {
        this.nextVideo = this.course.videos[currentVideoIndex + 1];
        this.setCourseVideoRoute(this.nextVideo); 
      }
    },
    getPreviousCourseVideo() {
      var currentVideoIndex = this.course.videos.findIndex(
        (courseVideo) => courseVideo["@id"] == this.video["@id"]
      );
      if ((currentVideoIndex - 1)  >= 0 && this.course.videos.length >= (currentVideoIndex - 1)) {
        this.previousVideo = this.course.videos[currentVideoIndex - 1];
        this.setCourseVideoRoute(this.previousVideo);
      }
    },
  },
};
</script>
